module.exports = __webpack_public_path__ + "static/NeuroFlow-2437c3b2a05a77a98da51a2a47d3209a.jpg";